import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { TravelAgentProfileService } from '../travel-agent-profile.service';
import { TravelAgentProfile } from '../travel-agent-profile';

@Component({
    selector: 'app-travel-agent-profile',
    templateUrl: './travel-agent-profile.component.html',
    styleUrls: ['./travel-agent-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class TravelAgentProfileComponent implements OnInit {
	addressTypes: any;
	titles: { name: string; value: string; }[];
	countries: any;
	states: any;
	percentages: any;
	affiliationTypes: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private travelAgentProfileService: TravelAgentProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private constantService: ConstantService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.travelAgentProfile = data.travelAgentProfile,
			this.statuses = travelAgentProfileService.portalAcceses;
			this.addressTypes = travelAgentProfileService.addressTypes;
			this.titles = travelAgentProfileService.titles;
			this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
			this.percentages = travelAgentProfileService.percentages;
			this.affiliationTypes = travelAgentProfileService.affiliationTypes;
	}

	@Input() travelAgentProfile: TravelAgentProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	travelAgentProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	// reservations tab
	reservations: any[] = [];
	reservationsLoading = false;

	// w9 tab
	w9StatusOptions = [
		{ label: 'Not Submitted', value: null },
		{ label: 'Pending Review', value: 'PENDING' },
		{ label: 'Received', value: 'RECEIVED' },
		{ label: 'Approved', value: 'APPROVED' },
		{ label: 'Rejected', value: 'REJECTED' }
	];

	validationMessages = {
		travelAgentProfileId: [],
		firstName: [
			{ type: 'required', message: 'Required' }
		],
		lastName: [
			{ type: 'required', message: 'Required' }
		],
		emailAddress: [
			{ type: 'required', message: 'Email is required' },
			{ type: 'email', message: 'Enter a valid email address' }
		],
		mobilePhone: [
			{ type: 'required', message: 'Mobile is required' }
		],
		suffix: [],
		title: [],
		iatalicNum: [],
		defaultCommissionPCT: [],
		adrType: [],
		adrCompanyName: [],
		adrStreet: [],
		adrStreet2: [],
		adrCity: [],
		adrState: [],
		adrIsland: [],
		adrPostalCode: [],
		adrCountry: [],
		adrPhone: [],
		portalAccess: [],
		portalRegisterDate: [],
		opsNotes: [],
		userId: [],
		agencyName: [],
		websiteUrl: [],
		trueNum: [],
		arcNum: [],
		cliaNum: [],
		affiliationType: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole travelAgentProfile object
		if (this.travelAgentProfile) {
			this.travelAgentProfileId = this.travelAgentProfile.travelAgentProfileId;
			if (this.travelAgentProfile.portalRegisterDate != undefined && this.travelAgentProfile.portalRegisterDate != null) {
				this.travelAgentProfile.portalRegisterDate = moment.utc(this.travelAgentProfile.portalRegisterDate).toDate();
			}
			this.fixDates();
			this.form1.patchValue(this.travelAgentProfile);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.travelAgentProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.travelAgentProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.travelAgentProfile = res.data.travelAgentProfile;
						this.doAdd.emit(this.travelAgentProfile);
					},
					(err: any) => {
						console.log('travelAgentProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('travelAgentProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.travelAgentProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.travelAgentProfile = res.data.travelAgentProfile;
						this.doUpdate.emit(this.travelAgentProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	activatePortalAccess() {
		this.formLoading = true;
		this.travelAgentProfileService.activatePortalAccess(this.travelAgentProfileId)
			.subscribe(
				(res: any) => {
					this.messageService.add({ severity: 'success', summary: 'Invite Sent', detail: res.message });
					this.travelAgentProfile = res.data.travelAgentProfile;
					this.form1.patchValue({ portalAccess: this.travelAgentProfile.portalAccess, portalRegisterDate: this.travelAgentProfile.portalRegisterDate });
				},
				(err: any) => {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not activate portal access.' });
					console.log('activatePortalAccess FAIL: ' + JSON.stringify(err));
				},
				() => { this.formLoading = false; });
	}

	formDelete() {
		try {
			this.travelAgentProfileService.delete(this.travelAgentProfile.travelAgentProfileId)
				.subscribe(
					(res: any) => {
						console.log('travelAgentProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.travelAgentProfile);
					},
					(err: any) => {
						console.log('travelAgentProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	loadReservations() {
		if (!this.travelAgentProfileId) return;
		this.reservationsLoading = true;
		this.travelAgentProfileService.getAgentReservations(this.travelAgentProfileId).subscribe(
			(res: any) => {
				this.reservations = res.data?.reservations || [];
			},
			(err: any) => {
				console.log('loadReservations FAIL: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load reservations.' });
			},
			() => { this.reservationsLoading = false; });
	}

	markCommissionPaid(reservation: any) {
		const today = new Date().toISOString().slice(0, 10);
		this.travelAgentProfileService.markCommissionPaid(reservation.reservationId, today).subscribe(
			(res: any) => {
				reservation.commissionPayStatus = 'PAID';
				reservation.commissionPayDate = today;
				this.messageService.add({ severity: 'success', summary: 'Commission Paid', detail: 'Reservation ' + reservation.reservationId + ' marked as paid.' });
			},
			(err: any) => {
				console.log('markCommissionPaid FAIL: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not mark commission as paid.' });
			});
	}

	downloadCommissionCsv(): void {
		if (!this.reservations?.length) return;
		const headers = ['Res#', 'Guest', 'Check In', 'Check Out', 'Nights', 'Booking Amt', 'Tax Amt', 'Total Amt', 'Commission %', 'Commission Amt', 'Pay Status', 'Pay Date'];
		const rows = this.reservations.map((r: any) => [
			r.reservationId, r.guestName,
			r.checkInDate ? new Date(r.checkInDate).toLocaleDateString() : '',
			r.checkOutDate ? new Date(r.checkOutDate).toLocaleDateString() : '',
			r.numNights, r.bookingAmt?.toFixed(2), r.taxAmt?.toFixed(2), r.totalAmt?.toFixed(2),
			r.agentCommissionPct, r.commissionAmt?.toFixed(2),
			r.commissionPayStatus || 'UNPAID', r.commissionPayDate || ''
		]);
		const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
		const blob = new Blob([csv], { type: 'text/csv' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `commissions-agent-${this.travelAgentProfile?.travelAgentProfileId}.csv`;
		a.click();
		URL.revokeObjectURL(url);
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			travelAgentProfileId: [this.travelAgentProfileId],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			emailAddress: ['', Validators.compose([
				Validators.required,
				Validators.email
			])],
			mobilePhone: [],
			suffix: [],
			title: [],
			iatalicNum: [],
			defaultCommissionPCT: [],
			adrType: [],
			adrCompanyName: [],
			adrStreet: [],
			adrStreet2: [],
			adrCity: [],
			adrState: [],
			adrIsland: [],
			adrPostalCode: [],
			adrCountry: [],
			adrPhone: [],
			portalAccess: [],
			portalRegisterDate: [],
			opsNotes: [],
			userId: [0],
			agencyName: [],
			websiteUrl: [],
			trueNum: [],
			arcNum: [],
			cliaNum: [],
			affiliationType: [],
			w9Status: [],
			w9Url: [],
			w9UploadDate: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.travelAgentProfile.travelAgentProfileDate = moment(this.travelAgentProfile.travelAgentProfileDate).toDate();
	}
}
